module.exports = "/fonts/vendor/@bcgov/bootstrap-theme/dist/bc-sans/BCSans-Italic.woff2?bcfa60021b3e0a5e6c1611fcefcd7e4c";